import { render, staticRenderFns } from "./FATConfig.vue?vue&type=template&id=3f839f3d&scoped=true&"
import script from "./FATConfig.vue?vue&type=script&lang=js&"
export * from "./FATConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f839f3d",
  null
  
)

export default component.exports